import * as yup from 'yup'
import { MICRO_MOBILITY_VEHICLE_TYPES } from 'src/constants/partnerDriver/constants'
import { VehicleType } from 'src/constants/partnerDriver/enums'

const VEHICLE_TYPE_VALUES: string[] = Object.values(VehicleType)

const isMicroMobility = (vehicleType: unknown): boolean => {
  return MICRO_MOBILITY_VEHICLE_TYPES.includes(vehicleType as VehicleType)
}

// Mirrors the backend: year, make, model and VIN are required unless the vehicle is a bicycle,
// e-bike, e-scooter or scooter. Motorcycle still requires all four.
const requiredUnlessMicroMobility = (message: string) => {
  return yup
    .string()
    .trim()
    .when('vehicleType', {
      is: isMicroMobility,
      then: (schema) => {
        return schema
      },
      otherwise: (schema) => {
        return schema.required(message)
      },
    })
}

export const completeVehicleInsuranceFormValidator = yup.object({
  insuranceDocument: yup
    .mixed<File>()
    .nullable()
    .test('required', 'Attach the insurance document', (value) => {
      return Boolean(value)
    }),
  policyDocument: yup.mixed<File>().nullable(),
  // Not `oneOf`: Formik turns '' into undefined before validating and yup 1.x `oneOf` skips
  // undefined, so a blank select would pass. An explicit membership test rejects both, with one
  // message (no separate `required`).
  vehicleType: yup.string().test('vehicle-type', 'Choose a vehicle type', (value) => {
    return VEHICLE_TYPE_VALUES.includes(value ?? '')
  }),
  year: requiredUnlessMicroMobility('Choose the vehicle year'),
  carMake: requiredUnlessMicroMobility('Enter the car make'),
  carModel: requiredUnlessMicroMobility('Enter the car model'),
  vin: requiredUnlessMicroMobility('Enter the VIN'),
})
